export default __webpack_public_path__ + "static/media/sorry.c84058c2.png";